import React from 'react'
import { Skeleton } from './Skeleton'

const TableSkeletonRows = ({ rows = 8, colSpan = 100 }) => (
  <>
    {Array.from({ length: rows }).map((_, i) => (
      <tr key={`skeleton-row-${i}`} className="border-b border-divider">
        <td colSpan={colSpan} className="px-5 py-[14px]">
          <Skeleton height={16} />
        </td>
      </tr>
    ))}
  </>
)

export default TableSkeletonRows
